export enum GROUP_TYPE {
    DISABLED = 'disabled',
    INHERITED = 'inherited',
    MANUAL = 'manual',
}

export enum ASSET_GROUP_TYPE {
    COMPANY = 'Company',
    SITE = 'Site',
    BUILDING = 'Building',
    ROOM = 'Room',
    DEPARTMENT = 'Department',
    GROUP = 'Group',
}
